export const filters = [
  'Nu Rush Majors',
  'Xi Rush Majors',
  'Omicron Rush Majors',
  'Pi Rush Majors',
  'Rho Rush Majors',
  'Sigma Rush Majors',
  'Nu Rush Years',
  'Xi Rush Years',
  'Omicron Rush Years',
  'Pi Rush Years',
  'Rho Rush Years',
  'Sigma Rush Years',
  'Nu Rush Genders',
  'Xi Rush Genders',
  'Omicron Rush Genders',
  'Pi Rush Genders',
  'Rho Rush Genders',
  'Sigma Rush Genders',
  'Nu Pledge Majors',
  'Xi Pledge Majors',
  'Omicron Pledge Majors',
  'Pi Pledge Majors',
  'Rho Pledge Majors',
  'Sigma Pledge Majors'
];



// WEBPACK FOOTER //
// ./src/containers/DataApp/components/RushData/data/filters.js